import { defaults } from 'ol/control/defaults'
import GeoJSON from 'ol/format/GeoJSON'
import TopoJSON from 'ol/format/TopoJSON'
import Group from 'ol/layer/Group'
import VectorLayer from 'ol/layer/Vector'
import Map from 'ol/Map'
import { get as projGet } from 'ol/proj'
import VectorSource from 'ol/source/Vector'
import View from 'ol/View'

import { BaseMapControl } from '../controls/basemapSelector'
import { LayerButtonControl } from '../controls/mapLayers'
import {
  addDecisionButtons, createApprovalBtn, createRejectionBtn,
  getStateIndex, showSubmitBtn
} from './decisionButtons'
import { getReadableValue } from './getset'
import { asTitle, translate } from '../helperFunctions'
import { id2name } from '../functions'
import { createWMS, id2WMS, newBaseMap } from '../map/layers'
import { map, vectorIntersectsWms } from '../map/tools'
import { addD3Style } from './minimapD3'
import { changes, getChanges } from './requests'
import { debug, maxZoom } from '../storage'
import { getOlStyle } from '../styles'

onInit('changesOverview');

function onInit(elmntId) {
  const el = document.getElementById(elmntId);
  // correct initial resize misbehaviuor
  // el.style.left = (window.innerWidth - 20 - el.offsetWidth) + 'px';
  // if (window.innerWidth < 768) { return; } // deactivate on mobile
  // Make the DIV element draggagle:
  // https://www.w3schools.com/howto/howto_js_draggable.asp
  dragElement(elmntId, 'topDragHandle');
  dragElement(elmntId, 'sideDragHandle');
  // make it resizable:
  // https://blog.codezero.xyz/building-interactive-elements-with-html-and-javascript-resizing/
  resizeElementFromTopLeft(elmntId, 'northWest-resizeHandle');
  resizeElement(elmntId, 'resizeHandle');
  addDecisionButtons();
}

function dragElement(elmntId, handleId) {
  const elmnt = document.getElementById(elmntId);
  const handle = document.getElementById(handleId);
  let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  if (handle) {
    // if present, the handle is where you move the DIV from:
    handle.onmousedown = dragMouseDown;
    handle.ontouchstart = dragTouchStart;
  } else {
    // otherwise, move the DIV from anywhere inside the DIV:
    elmnt.onmousedown = dragMouseDown;
    elmnt.ontouchstart = dragTouchStart;
  }
  function dragMouseDown(e) {
    e.preventDefault(); // avoid IPad scrolling bounce effect
    elmnt.style.opacity = '0.7';
    window.addEventListener('selectstart', disableSelection, false);
    // e = e || window.event;
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }
  function dragTouchStart(e) {
    e.preventDefault(); // avoid IPad scrolling bounce effect
    elmnt.style.opacity = '0.7';
    window.addEventListener('selectstart', disableSelection, false);
    // e = e || window.event;
    // get the mouse cursor position at startup:
    pos3 = e.touches[0].clientX;
    pos4 = e.touches[0].clientY;
    document.ontouchend = closeDragElement;
    // call a function whenever the cursor moves:
    document.ontouchmove = elementDrag;
  }
  function elementDrag(e) {
    // const generalized = e ? e : window.event;
    const x = (e instanceof MouseEvent) ? e.clientX : e.touches[0].clientX;
    const y = (e instanceof MouseEvent) ? e.clientY : e.touches[0].clientY;
    const max_w = document.body.offsetWidth;
    const max_h = document.body.offsetHeight;
    const mouseWithinRight = (x < max_w);
    const mouseAboveBottom = (y < max_h);
    // calculate the new cursor position:
    pos1 = pos3 - x;
    pos2 = pos4 - y;
    pos3 = x;
    pos4 = y;
    // set the element's new position:
    const old_t = elmnt.offsetTop;
    const old_l = elmnt.offsetLeft;
    const t = old_t - pos2;
    const l = old_l - pos1;
    elmnt.style.top = ((t >= 0 && mouseAboveBottom) ? t : old_t) + 'px';
    elmnt.style.left = ((l >= 0 && mouseWithinRight) ? l : old_l) + 'px';
  }
  function closeDragElement() {
    elmnt.style.opacity = '1';
    window.removeEventListener('selectstart', disableSelection, false);
    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.ontouchend = null;
    document.onmousemove = null;
    document.ontouchmove = null;
  }
  function disableSelection(event) {
    event.preventDefault();
  }
}

const updateMinimapsHeight = () => {
  const minimap = document.getElementsByClassName('minimap');
  const length = minimap.length;
  const h = document.getElementById('hf').offsetWidth / 2 + 'px';
  for (let i = 0 ; i < length ; i++) minimap[i].style.height = h;
}

function resizeElementFromTopLeft(elementId, handleId) {
  const element = document.getElementById(elementId);
  const resizeHandle = document.getElementById(handleId);
  resizeHandle.addEventListener('mousedown', initialiseResize, false);
  resizeHandle.addEventListener('touchstart', initialiseResize, false);
  element.onmouseup = decideResizeMinimaps;
  element.ontouchend = decideResizeMinimaps;
  function initialiseResize(event) {
    event.preventDefault(); // avoid IPad scrolling bounce effect
    window.addEventListener('mousemove', startResizing, false);
    window.addEventListener('touchmove', startResizingWithTouch, false);
    window.addEventListener('mouseup', stopResizing, false);
    window.addEventListener('touchend', stopResizing, false);
    window.addEventListener('selectstart', disableSelection, false);
  }
  function startResizing(event) {
    const x = event.clientX;
    const y = event.clientY;
    northWestResize(x,y);
  }
  function startResizingWithTouch(event) {
    const x = event.touches[0].clientX;
    const y = event.touches[0].clientY;
    northWestResize(x,y);
  }
  function northWestResize(x, y) {
    const oldPositionX = element.offsetLeft;
    const oldPositionY = element.offsetTop;
    const newPositionX = (x < 0) ? 0 : x;
    const newPositionY = (y < 0) ? 0 : y;
    // console.log(x,y, element.offsetLeft, element.offsetTop);
    const oldWidth = element.offsetWidth;
    const oldHeight = element.offsetHeight;
    const deltaX = newPositionX - oldPositionX;
    const deltaY = newPositionY - oldPositionY;
    const newWidth = oldWidth - deltaX;
    const newHeight = oldHeight - deltaY;
    const cs = window.getComputedStyle(element);
    const minWidth = cs.minWidth.slice(0, -2);
    const minHeight = cs.minHeight.slice(0, -2);
    if (newWidth >= minWidth) {
      element.style.left = newPositionX + 'px';
      element.style.width = newWidth + 'px';
    }
    if (newHeight >= minHeight) {
      element.style.top = newPositionY + 'px';
      element.style.height = newHeight + 'px';
    }
    updateMinimapsHeight();
  }
  function stopResizing() {
    resizeMinimaps(); // called in Chrome, not in Firefox
    window.removeEventListener('mousemove', startResizing, false);
    window.removeEventListener('touchmove', startResizingWithTouch, false);
    window.removeEventListener('mouseup', stopResizing, false);
    window.removeEventListener('touchend', stopResizing, false);
    window.removeEventListener('selectstart', disableSelection, false);
  }
  function disableSelection(event) {
    event.preventDefault();
  }
}

function resizeElement(elementId, handleId) {
  const element = document.getElementById(elementId);
  const resizeHandle = document.getElementById(handleId);
  resizeHandle.addEventListener('mousedown', initialiseResize, false);
  resizeHandle.addEventListener('touchstart', initialiseResize, false);
  element.onmouseup = decideResizeMinimaps;
  element.ontouchend = decideResizeMinimaps;
  function initialiseResize(event) {
    event.preventDefault(); // avoid IPad scrolling bounce effect
    window.addEventListener('mousemove', startResizing, false);
    window.addEventListener('touchmove', startResizingWithTouch, false);
    window.addEventListener('mouseup', stopResizing, false);
    window.addEventListener('touchend', stopResizing, false);
    window.addEventListener('selectstart', disableSelection, false);
  }
  function startResizing(event) {
    element.style.width = (event.clientX - element.offsetLeft) + 'px';
    element.style.height = (event.clientY - element.offsetTop) + 'px';
    updateMinimapsHeight(); // called in Chrome, not in Firefox
  }
  function startResizingWithTouch(event) {
    element.style.width = (event.touches[0].clientX - element.offsetLeft) + 'px';
    element.style.height = (event.touches[0].clientY - element.offsetTop) + 'px';
    updateMinimapsHeight(); // called in Chrome, not in Firefox
  }
  function stopResizing() {
    resizeMinimaps(); // called in Chrome, not in Firefox
    window.removeEventListener('mousemove', startResizing, false);
    window.removeEventListener('touchmove', startResizingWithTouch, false);
    window.removeEventListener('mouseup', stopResizing, false);
    window.removeEventListener('touchend', stopResizing, false);
    window.removeEventListener('selectstart', disableSelection, false);
  }
  function disableSelection(event) {
    event.preventDefault();
  }
}

const maxChanges = 120;
export function showChangesOverview() {
  // remove rows from table, to avoid duplicates after multiple clicks
  const t = document.getElementById('overviewBody');
  while (t.hasChildNodes()) t.removeChild(t.lastChild);
  // show overview table
  changesOverview.style.display = 'block';
  // focus on it to be able to closeIfEsc:
  changesOverview.focus();
  hideDropdownLists();
  overviewFoot.hidden = true;
  getChanges().then(ordered => {
    ordered.forEach((item, index) => {
      if (debug < 16) console.log(item, index);
      if (index < 9) addToOverviewList(item, index);
      else if (index < maxChanges) setTimeout(
        () => addToOverviewList(item, index), 1000
      );
    });
    if (ordered.length > maxChanges) {
      manglendeEndringer.innerHTML = ordered.length - maxChanges;
      overviewFoot.hidden = false;
    }
  }).catch(e => console.log(e));
}

export const closeOverview = () => changesOverview.style.display = 'none';

export function closeIfEsc(event) {
  if (event.key === 'Escape') { closeOverview(); }
}

export function helpModal() {
  $("#ks-help-modal").openModal();
  // focus on modal to avoid closing changes overview too on escape press
  // document.getElementById('ks-help-modal').click();
  document.getElementById('ks-help').blur();
}

export const addToOverviewList = (item, i0) => {
  const index = i0 + 1;
  const tableBody = document.getElementById('overviewBody');
  const row = document.createElement('tr');
  item.inTheList = row;
  const tdCouple = document.createElement('td');
  const layer_id = item['layer_id'];
  const layer_name = item['layer_name'];
  const layer_type = item['layer_type'];
  const id_before = item['id_before'];
  let map_before = item['map_before'];
  const id_after = item['id_after'];
  const map_after = item['map_after'];
  if (!map_after) {
    console.log('Check this out: map_after is null, something wrong from backend');
    return;
  }
  if (!map_before || map_before === '{}') { // new geometry
    // console.log('New geometry');
    map_before = map_after; // no need for a deep copy because they are strings, not objects
  }
  const newGeometry = isItNew(layer_id, map_before, map_after);
  if (newGeometry) { // show ghost feature on left map
    map_before = map_before.replace('"slette_status_kode": 0', '"slette_status_kode": 1');
  }
  if (debug < 16 && index === 1) {
    console.log(
      'Id:', layer_id,
      ' - Name:', layer_name,
      ' - Geometry:', layer_type,
      ' - User:', item['saksbehandler_after']
    );
  }
  const mapId = 'minimap' + index;
  const parent_name = id2name[layer_id].parent_name;
  const shownName = (layer_name === 'Linje' || layer_name === 'Punkt') ?
    parent_name : layer_name;
  tdCouple.appendChild(getPropertyTable(layer_id, shownName, map_before, map_after, index));
  tdCouple.appendChild(createCoupleTable(item, index, mapId));
  const check = document.createElement('th');
  check.onmouseenter = () => showProperties(index, true);
  check.onmouseleave = () => showProperties(index, false);
  // check.onmousedown = () => showProperties(index, true);
  check.onmouseup = () => showProperties(index, false);
  check.ontouchstart = () => showProperties(index, true);
  check.ontouchend = () => showProperties(index, false);
  const cb = document.createElement('input');
  cb.type = 'checkbox';
  cb.id = 'change#' + index;
  cb.value = index;
  // cb.checked = true;
  cb.indeterminate = true;
  cb.className = 'custom-cb';
  let i = cb.indeterminate;
  let c = cb.checked;
  cb.data = {
    changedAllCheckboxes: false,
    state: { indeterminate: true, checked: false }
  };

  function switch3States() {
    const globalState = cb.data.state;
    const localState = { indeterminate: i, checked: c };
    const oldState = cb.data.changedAllCheckboxes ? globalState : localState;
    cb.data.changedAllCheckboxes = false;
    const state = [
      { indeterminate: true, checked: false },
      { indeterminate: false, checked: true },
      { indeterminate: false, checked: false }
    ];
    const nextState = state[(getStateIndex(oldState) + 1) % 3];
    i = nextState.indeterminate;
    c = nextState.checked;
    cb.indeterminate = i;
    cb.checked = c;
    // // prevent the default action; we already toggled the element
    // return false;
  }
  cb.onclick = switch3States;
  cb.onchange = showSubmitBtn;
  const l = document.createElement('label');
  l.htmlFor = 'change#' + index;
  l.innerHTML = index;
  check.appendChild(cb);
  check.appendChild(l);
  check.appendChild(document.createElement('br'));
  check.appendChild(createApprovalBtn(index));
  check.appendChild(createRejectionBtn(index));
  row.appendChild(tdCouple);
  row.appendChild(check);
  tableBody.appendChild(row);
  getOlStyle(layer_id, layer_type).then(style => {
    const map_b = createMinimap(mapId + '_b', map_before, id_before, style.ol);
    const map_a = createMinimap(mapId + '_a', map_after, id_after, style.ol);
    if (index === 1) updateScrollbarGhost(); // etter minst et kart er opprettet
    if (layer_type === 'line') {
      addD3Style(mapId + '_b', map_before, style.json);
      addD3Style(mapId + '_a', map_after, style.json);
    }
    const pp = map_b.getView().getProjection().getCode();
    const wms = createWMS(id2WMS[layer_id]).image[pp];
    // map_b.addLayer(wms);
    // Get wms layer group, n.b. it is not map_b.getLayerGroup():
    const wmses = map_b.getLayers().item(map_b.get('groupPosition'));
    wmses.getLayers().push(wms);
    // wmses.getLayers().push(createTileWMS(layer_id));
    const årstidsbeite = id2WMS[layer_id].slice(-8) === 'beiteWMS';
    if (årstidsbeite) {
      wmses.getLayers().push(createWMS('utenforWMS').image[pp]);
      const wmses_a = map_a.getLayers().item(map_a.get('groupPosition'));
      wmses_a.getLayers().push(createWMS('utenforWMS').image[pp]);
      if (newGeometry) {
        map_a.once('loadend', () => { // wait for wms to be loaded
          if (vectorIntersectsWms(map_a)) {
            const text = [
              '', '<b class="red-font">Utenfor reinbeitedistrikt</b>', ''
            ];
            const properties = document.getElementById('propertyTable' + index);
            properties.appendChild(createTableRow(text));
          }
        });
      }
    }
  });
  return row;
};

function createCoupleTable(item, index, mapId) {
  const hf = document.getElementById('hf');
  const height = hf.offsetWidth / 2; // relative to width
  const coupleTable = document.createElement('table');
  coupleTable.className = 'coupleTable';
  const row = document.createElement('tr');
  const before = document.createElement('td');
  const after = document.createElement('td');
  before.id = mapId + '_b';
  before.className = 'minimap';
  before.style.height = height + 'px';
  // before.innerHTML = item['id_before'];
  after.id = mapId + '_a';
  after.className = 'minimap';
  after.style.height = height + 'px';
  // after.innerHTML = item['id_after'];
  row.appendChild(before);
  row.appendChild(after);
  coupleTable.appendChild(row);
  return coupleTable;
}

// Initially bring all maps to the same zoom to be able to compare dimensions
let commonZoom = 17;
function createMinimap(targetId, jsonString, geoId, style) {
  const idx = targetId.slice(7, -2);
  // const currentProjection = map.getView().getProjection();
  // console.log(jsonString);
  // const json = JSON.parse(jsonString);
  // console.log(json);
  // const geometryProjection = json.crs.properties.name;
  // graatoner.setSource(graa35);

  const jFormat = jsonString.type === 'Topology' ? TopoJSON : GeoJSON;
  const features = jsonString ? new jFormat({
    dataProjection: projGet('EPSG:4326')
  }).readFeatures(jsonString) : null;

  const vectorUtm = projectionFromFeature(features[0]);

  if (features) {
    const src = 'EPSG:4258';
    const dest = vectorUtm;
    features[0].getGeometry().transform(src, dest);
  }

  const miniVectorLayer = new VectorLayer({
    source: new VectorSource({ features: features }),
    style: style,
    zIndex: 2
  });
  miniVectorLayer.set('minimap', targetId.slice(7));
  miniVectorLayer.set('geoId', geoId);

  const baseType = $('.bg-highlight')[0].id;

  const rx = (targetId.slice(-1) === 'a');
  const minimapControls = rx ? [
    new BaseMapControl({ id: 'B' + idx }),
    new LayerButtonControl({ id: 'K' + idx })
  ] : [];

  const minimap = new Map({
    target: targetId,
    // layers: [ graatoner, miniVectorLayer ],
    // layers: [ map.getLayers().getArray()[0], miniVectorLayer ],
    // groupPosition: 1,
    layers: [
      // new Tile({ source: new OSM() }), // fix flickering
      // basemap[baseType][vectorUtm],
      newBaseMap(baseType, vectorUtm.slice(-2), true),
      new Group({ id: 'wmsGroup', layers: [], zIndex: 2 }),
      miniVectorLayer
    ],
    controls: defaults({
      attribution: false,
      rotate: false,
      zoom : false
    }).extend(minimapControls),
    view: new View({
      center: [574899, 7798888],
      maxZoom: maxZoom,
      minZoom: 1,
      zoom: 2,
      projection: vectorUtm
    })
  });
  minimap.set('groupPosition', 1); // keep track of group index, in case of OSM
  document.getElementById(targetId).data = minimap;

  const v = minimap.getView();

  // link paired maps
  if (targetId.slice(-1) === 'a') {
    const twinId = targetId.slice(0, -1) + 'b';
    const twinMap = document.getElementById(twinId).data;
    twinMap.setView(v);
  }
  // zoom to layer
  if (features) {
    v.fit(miniVectorLayer.getSource().getExtent(), { size: minimap.getSize() });
    const z = v.getZoom(); // etter 912 minimap (456 par), z er alltid 1
    // console.log(targetId, idx, z);
    if (1 < z && z < commonZoom) commonZoom = z;
  }

  // // initially set same zoom (furthest), to be able to compare dimensions
  // if (changes.length + '_a' === targetId.slice(7) ) // siste kart
  //   setCommonZoom(commonZoom);

  return minimap;
}

function decideResizeMinimaps(e) { // for Firefox
  if (e.target.id === 'changesOverview') {
    updateMinimapsHeight();
    resizeMinimaps();
  }
  return;
}
function resizeMinimaps() {
  const minimaps = document.getElementsByClassName('minimap');
  const l = minimaps.length;
  // console.log(minimaps[0].data.getSize());
  for (let i = 0; i < l; i++) {
    if (minimaps[i].data) minimaps[i].data.updateSize();
  }
  // console.log(minimaps[0].data.getSize()); // it increases when the map is not alone as dom element
  updateScrollbarGhost();
}

function getPropertyTable(id, name, be, af, i) {
  const propertyTable = document.createElement('table');
  propertyTable.className = 'overlayList';
  propertyTable.hidden = true;
  if (!be && !af) return propertyTable;
  const jbe = be ? JSON.parse(be) : null;
  const jaf = af ? JSON.parse(af) : null;
  // // When receiving TopoJSON:
  // const pbe = jbe ? jbe.objects.collection.geometries[0].properties : {};
  // const paf = jaf ? jaf.objects.collection.geometries[0].properties : {};
  // When receiving GeoJSON:
  const pbe = jbe ? jbe.features[0].properties : {};
  const paf = jaf ? jaf.features[0].properties : {};
  if (debug < 15 && i === 1) console.log(pbe, paf);
  const p = jbe ? pbe : paf;
  propertyTable.id = 'propertyTable' + i;
  const newGeo = isItNew(id, be, af);
  // const deletedGeometry = (pbe['slette_status_kode'] === 0 && paf['slette_status_kode'] === 1);
  const deleted = (paf['slette_status_kode'] === 1);
  addJsonToPropertyTable('', p, pbe, paf, newGeo, deleted, name, propertyTable);
  return propertyTable;
}

const addJsonToPropertyTable = (pk, p, pbe, paf, newGeo, del, name, table) => {
  const nested = typeof p === 'object' && !Array.isArray(p) && p !== null;
  if (nested) Object.keys(p).forEach(k =>
    addJsonToPropertyTable(k, p[k], pbe[k], paf[k], newGeo, del, name, table)
  ); else {
    const rowCells = mapToReadableText(pbe, pk, paf, newGeo, del, name);
    if (rowCells) table.appendChild(createTableRow(rowCells));
  }
};

function showProperties(i, show) {
  const pTable = document.getElementById('propertyTable' + i);
  if (pTable) { pTable.hidden = !show };
}

function mapToReadableText(v1, title, v2, isNew, isDeleted, layer) {
  if (!v2 || ['editable', 'status'].includes(title)) return null;
  const readableTitle = translate(asTitle(title));
  let t = [v1, readableTitle, v2];
  if (title === 'id') {
    const adj = isDeleted ? 'Slettet' : (isNew ? 'Ny' : 'Samme');
    t = ['', '<b>' + adj + ' geometri (' + nbText(layer) + ')</b>', ''];
  } else if (v2 === null) t = null;
  else if (isNew) t = ['', readableTitle, v2]; else {
    if (t[0] === '' || t[0] === null) t[0] = '--';
    if (t[2] === '' || t[2] === null) t[2] = '--';
  }
  if (t) { // might be null
    t[0] = getReadableValue(t[0], title);
    t[2] = getReadableValue(t[2], title);
  }
  // return [getReadableValue(t[0], title), t[1], getReadableValue(t[2], title)];
  return t;
}

function nbText(breakableText) {
  return breakableText.split(' ').join('&nbsp;');
}

function createTableRow(c) {
  const tr = document.createElement('tr');
  const tdl = document.createElement('td');
  tdl.style = 'text-align: right';
  tdl.className = 'sideColumn';
  tdl.innerHTML = c[0];
  const tdm = document.createElement('td');
  tdm.style = 'text-align: center';
  tdm.className = 'middleColumn';
  tdm.innerHTML = c[1];
  const tdr = document.createElement('td');
  tdr.style = 'text-align: left';
  tdr.className = 'sideColumn';
  tdr.innerHTML = c[2];
  tr.appendChild(tdl);
  tr.appendChild(tdm);
  tr.appendChild(tdr);
  return tr;
}

function setCommonZoom(z) {
  const l = changes.length;
  for (let i = 1; i <= l; i++) {
    const ith = document.getElementById('minimap' + i + '_b');
    if (!ith) continue;
    const map_b = ith.data;
    if (map_b) map_b.getView().setZoom(z);
  }
}

function hideDropdownLists() {
  const ddl = document.getElementsByClassName('rein-dropdown');
  const l = ddl.length;
  for (let i = 0; i < l; i++) ddl[i].hidden = true;
}

// function createBackgroundLayersBtn() {
//   const b = document.createElement('button');
//   b.id = 'K_all';
//   // b.className = 'layers-button';
//   b.innerHTML = '<i class="material-icons">tune</i>';
//   b.title = 'Andre kartlag';
//   const d = document.createElement('div');
//   d.id = 'div-K_all';
//   d.className = 'layers-button ol-unselectable ol-control';
//   d.appendChild(b);
//   return d;
// }

function updateScrollbarGhost() {
  const s = document.getElementsByClassName('scrollable')[0];
  const scrollbarWidth = s.offsetWidth - s.scrollWidth; // depends on browser
  // console.log('scrollbar width is', scrollbarWidth, 'px');
  const sg = document.getElementById('scrollbarGhost');
  // remove 20% of its width too
  sg.style.width = (scrollbarWidth * 0.8) + 'px';

  // const h3 = document.getElementById('overviewHeaderTh');
  // const tr1 = document.getElementById('overviewBody').firstChild;
  // if (tr1) {
  //   const whole = s.offsetWidth;
  //   const td1 = tr1.firstChild;
  //   if (td1) {
  //     const twinMaps = td1.offsetWidth;
  //     console.log(twinMaps, td1);
  //     const thPlusScroll = whole - twinMaps;
  //     console.log(thPlusScroll);
  //
  //     console.log(whole, twinMaps, thPlusScroll);
  //     h3.style.width = thPlusScroll + 'px';
  //   }
  // } else {
  //   h3.style.width = '20%';
  // }
}

export function fullScreen(e) {
  const w = e.target.parentNode;
  w.style.width = '100%';
  w.style.height = '100%';
  w.style.top = '0';
  w.style.left = '0';
  updateMinimapsHeight();
  resizeMinimaps();
}

function projectionFromFeature(f) {
  let utm = '35';
  const ext = f.getGeometry().getExtent();
  const e = (ext[2] + ext[0]) / 2;
  const n = (ext[3] + ext[1]) / 2;
  // Zone selection, rough method:
  // IF Nord < 65°: UTM32
  // IF Øst > 22°: UTM35
  // ELSE: UTM33
  if (n < 65) utm = '32';
  else if (e > 22) utm = '35';
  else utm = '33';
  return 'EPSG:258' + utm;
}

function isItNew(id, be, af) {
  const jbe = be ? JSON.parse(be) : null;
  const jaf = af ? JSON.parse(af) : null;
  // // When receiving TopoJSON:
  // const pbe = jbe ? jbe.objects.collection.geometries[0].properties : {};
  // const paf = jaf ? jaf.objects.collection.geometries[0].properties : {};
  // When receiving GeoJSON:
  const pbe = jbe ? jbe.features[0].properties : {};
  const paf = jaf ? jaf.features[0].properties : {};
  const mainProperty = { // could be replaced by a config file
    RAN_L: 'anleggstype', RAN_P: 'anleggstype', RAV_F: 'nd', RBH_F: 'reindriftsanleggstype',
    RDG_F: 'nd', REB_F: 'nd', REO_F: 'nd',
    RHS_F: 'reindrift_sesongomrade_kode', RHV_F: 'reindrift_sesongomrade_kode',
    RKO_F: 'nd', RKS_F: 'nd', ROP_F: 'nd', RRO_L: 'nd', RRO_P: 'nd',
    RSI_F: 'nd', RSO_F: 'reindrift_sesongomrade_kode', RTR_L: 'nd',
    RVI_F: 'reindrift_sesongomrade_kode', RVR_F: 'reindrift_sesongomrade_kode'
  }
  const mp = mainProperty[id];
  const emptyMain = (mp === 'nd' || pbe[mp]) ? false : true;
  // const emptyId = pbe['saksbehandler'] ? false : true;
  const emptyId = pbe['reinbeitebruker_id'] ? false : true;
  const identical = (be === af);
  // needed for points:
  const undeleted = (pbe.slette_status_kode === 1 && paf.slette_status_kode === 0);
  return (identical || emptyId || emptyMain || undeleted);
}

